import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { BottomSheet } from "@/components/revanche/BottomSheet";
import { getReferral } from "@/lib/pay";
import { markReferralShown } from "@/lib/referral";

// « Invite 3 amis, gagne 20 crédits » — affiché à 2 moments seulement.
export const ReferralPopup = ({ open, onClose }) => {
    const [ref, setRef] = useState(null);
    const [msg, setMsg] = useState("");

    useEffect(() => {
        if (!open) return;
        markReferralShown();
        getReferral().then(setRef).catch(() => {});
    }, [open]);

    const share = async () => {
        if (!ref) return;
        const txt = `Rejoins-moi sur Revanche AI et découvre ton vrai score d'attirance : ${ref.link}`;
        if (navigator.share) { try { await navigator.share({ text: txt, url: ref.link }); } catch (e) {} }
        else { try { await navigator.clipboard.writeText(ref.link); setMsg("Lien copié"); } catch (e) {} }
    };

    return (
        <BottomSheet open={open} onClose={onClose} height="auto" testId="referral-popup">
            <div className="px-6 pt-2 pb-6 relative">
                <button data-testid="referral-close" onClick={onClose}
                    className="tap-feedback absolute right-4 top-1" style={{ color: "var(--text-secondary)" }}>
                    <X size={22} />
                </button>
                <h2 className="font-body font-bold text-white mt-4" style={{ fontSize: 24 }} data-testid="referral-title">
                    Invite 3 amis, gagne {ref?.bonus ?? 20} crédits
                </h2>
                <p className="font-body mt-2" style={{ fontSize: 15, color: "var(--text-secondary)" }}>
                    Partage ton lien. Dès que 3 amis s'inscrivent, tes crédits tombent.
                </p>
                <p className="font-display text-white mt-5" style={{ fontSize: 40, fontWeight: 800, lineHeight: 1 }} data-testid="referral-counter">
                    {ref?.invited ?? 0}<span style={{ color: "var(--text-secondary)", fontSize: 24 }}>/3</span>
                </p>
                {msg && <p className="font-body mt-2" style={{ fontSize: 13, color: "var(--red)" }}>{msg}</p>}
                <button data-testid="referral-share" onClick={share}
                    className="tap-feedback w-full mt-5 rounded-full font-body font-semibold text-white"
                    style={{ height: 56, background: "var(--red)" }}>
                    Partager mon lien
                </button>
            </div>
        </BottomSheet>
    );
};
